// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__1mbDV","header":"style_header__3Hnfu","icon":"style_icon__2zOfb"};